export default "__VITE_ASSET__de994b8c__"